import WithGASetup from '../../components/WithGASetup';
import DiscoverPsyPage from './DiscoverPageV3';

export default WithGASetup(DiscoverPsyPage);
